export const catalog_matrix = [
  {form_key:'payroll_periodicity_id', catalog_key:'payroll_periodicity'},
  {form_key:'roster_type_id', catalog_key:'roster_types',},
  {form_key:'payroll_system_id', catalog_key:'payroll_systems'},
]